import { z } from 'zod';

const text = z.string().nullish();
const person = z
  .looseObject({
    name: text.meta({ pii: 'name' }),
    businessName: text.meta({ pii: 'name' }),
    registrationNumber: text.meta({ pii: 'document' }),
    email: text.meta({ pii: 'email' }),
    zipCode: text.meta({ pii: 'address' }),
    addressName: text.meta({ pii: 'address' }),
    addressNumber: text.meta({ pii: 'address' }),
    addressComplement: text.meta({ pii: 'address' }),
  })
  .meta({ pii: 'name' });
export const bankSlipLineSchema = z.looseObject({
  id: z.string(),
  lineType: z.string(),
  detail: z.looseObject({
    createdAt: text,
    confirmationTransactionTypeValueDisplay: text,
    statusOperationValueDisplay: text,
    occurrenceReason: text,
    occurrenceCode: text,
    dueDate: text,
    paidCreditDay: text,
    debtCollectionProtocolNumber: text,
    debtCollectionName: text,
    debtCollectionCity: text,
    debtCollectionState: text,
    debtCollectionRegistryNumber: text,
    costs: text,
    error: text,
    createdBy: z.looseObject({ userIdDisplay: text }).nullish(),
    updatedBy: z.looseObject({ userIdDisplay: text }).nullish(),
  }),
});
export const bankSlipSchema = z.looseObject({
  id: z.string(),
  barCode: z.string().meta({ pii: 'document' }),
  numericLine: z.string().meta({ pii: 'document' }),
  amount: z.number(),
  walletCode: z.number(),
  walletCodeOrigem: z.number(),
  statusRegisterValue: z.string(),
  statusSettlementValue: z.string(),
  statusDebtCollectionValue: z.string(),
  statusRegisterValueDisplay: text,
  statusSettlementValueDisplay: text,
  statusDebtCollectionValueDisplay: text,
  dueDate: z.string(),
  createdAt: text,
  issuanceDate: text,
  settlementAt: text,
  overdueLimitDate: text,
  discountLimitDate: text,
  ourNumber: z.union([z.string(), z.number()]).nullish(),
  ourNumberDigit: text,
  isTransferred: z.boolean().optional(),
  discount: z.number().nullish(),
  deduction: z.number().nullish(),
  interestAmount: z.number().nullish(),
  fineAmount: z.number().nullish(),
  interestTypeValue: text,
  interestCodeValue: text,
  fineTypeValue: text,
  cancelReason: text,
  description: text,
  documentNumber: text,
  firstInstructionDebtCollection: text,
  secondInstructionDebtCollection: z.number().nullish(),
  paymentMethodDisplay: text,
  captureTypeDisplay: text,
  beneficiary: person.nullish(),
  payer: person.nullish(),
  guarantor: person.nullish(),
  fileInstructionLines: z.array(bankSlipLineSchema).default([]),
  fileConfirmationLines: z.array(bankSlipLineSchema).default([]),
});
export const bankSlipResponseSchema = z.looseObject({
  bankSlip: bankSlipSchema,
  npc: z.unknown().optional(),
  debtCollection: z.unknown().optional(),
});
export type BankSlip = z.output<typeof bankSlipSchema>;
export type BankSlipResponse = z.output<typeof bankSlipResponseSchema>;
export type BankSlipLine = z.output<typeof bankSlipLineSchema>;
export type BankSlipWalletContext = {
  readonly enableAutoSubmitToDebtCollection?: boolean | undefined;
  readonly bankSlipCosts?:
    | Partial<
        Record<
          | 'changeDueDate'
          | 'settlement'
          | 'debtCollection'
          | 'cancellation'
          | 'register'
          | 'debtCollectionCancellation'
          | 'discount',
          number | null | undefined
        >
      >
    | undefined;
};
export type OtherInformation = Record<string, unknown>;
export type SettlementBody = {
  paidAmount: string;
  confirmationTransactionTypeValue: string;
  paymentISPB: number | null;
  paymentAgency: number | null;
  paymentDate: string | null;
};
